// extracted by mini-css-extract-plugin
export default {"contractCell":"PendingScopeWorklistPage_contractCell__p903I","tableLink":"PendingScopeWorklistPage_tableLink__37pea","actions":"PendingScopeWorklistPage_actions__uo9P2"};